import {AfterViewInit, Component, isDevMode, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {RazorpayDataDataSource, RazorpayDataItem} from './razorpay-data-datasource';
import {RazorpayService} from "./razorpay.service";
import {DatePipe} from "@angular/common";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LoadingService} from "../../services/loading.service";
import {FinancialYearService} from "../../services/financial-year.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatDialog} from "@angular/material/dialog";
import {firstValueFrom} from "rxjs";
import {environment} from "../../../environments/environment";
import {
  AddedDonation,
  AddRazorpayDonationComponent
} from "./add-razorpay-donation/add-razorpay-donation.component";

@Component({
    selector: 'app-razorpay-data',
    templateUrl: './razorpay-data.component.html',
    styleUrls: ['./razorpay-data.component.css']
})
export class RazorpayDataComponent implements AfterViewInit, OnInit {
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    mStartDate!: Date
    mEndDate!: Date

    @ViewChild(MatTable) table!: MatTable<RazorpayDataItem>;
    // dataSource: RazorpayDataDataSource;
    dataSource: MatTableDataSource<any>;
    displayedColumns: string[] = ['email','contact' ,'amount', 'status', 'method','order_id', 'id','group', 'created_at', 'inDonations', 'action'];
  uniqueStatuses: string[] = ['captured', 'failed', 'refunded'];
    selectedStatus: string = '';

    response: any
    env = isDevMode() ? environment.testMode : environment.productionMode;
    //* payment id / order id -> the donation that already holds it
    donationIndex = new Map<string, AddedDonation>();

    /** Columns displayed in the assessment-table. Columns IDs can be added, removed, or reordered. */

    constructor(private readonly razorpay: RazorpayService,
                private readonly datePipe: DatePipe,
                private readonly mSnackbar: MatSnackBar,
                private readonly LoaderService : LoadingService,
                private readonly financialYearService: FinancialYearService,
                private readonly mFirestore: AngularFirestore,
                private readonly mDialog: MatDialog
    ) {
        this.dataSource = new MatTableDataSource<any>();
        this.dataSource.sort = this.sort;
        this.getUniqueStatuses();
        console.log('into razorpay-data component')
    }

  applyStatusFilter(status: string) {
    this.selectedStatus = status;
    this.dataSource.filter = status.trim().toLowerCase();
  }

  getUniqueStatuses() {
    this.uniqueStatuses = Array.from(
      new Set(this.dataSource.data.map((payment: any) => payment.status))
    );
  }

    ngAfterViewInit(): void {
        this.table.dataSource = this.dataSource;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    ngOnInit(): void {
        // Pre-fill the date range with the current financial year (search still requires an explicit click)
        const fy = this.financialYearService.getCurrentFinancialYear();
        this.mStartDate = fy.startDate;
        this.mEndDate = fy.endDate;
        // this.razorpay.getPayments().subscribe(res=>[
        //     this.response=res
        //
        // ])

    }

//     search() {
//         if (this.mStartDate != null && this.mEndDate != null) {
//             const startDate = this.datePipe.transform(this.mStartDate, 'yyyy-MM-dd')!!
//             const endDate = this.datePipe.transform(this.mEndDate, 'yyyy-MM-dd')!!
//             // const date = new Date()
//             // const endDate=new Date()
// // this.razorpay.getTransactionsByDateRange(this.datePipe.transform(startDate,'yyyy-MM-dd')!!,this.datePipe.transform(endDate,'yyyy-MM-dd')!!).subscribe(res=>{
//             this.razorpay.getTransactionsByDateRange(startDate, endDate).subscribe(res => {
//                 // alert(JSON.stringify(res))
//                 console.log('RAZORPAY', res)
//                 // @ts-ignore
//                 console.log('items', res["items"])
//                 // @ts-ignore
//                 this.dataSource = new MatTableDataSource<any>(res['items'])
//                 this.dataSource.sort = this.sort;
//                 this.dataSource.paginator = this.paginator;
//             })
//         } else this.mSnackbar.open('Please select a date range', '', {
//             duration: 3000,
//             panelClass: 'success'
//         })
//
//     }

  async search() {
    if (this.mStartDate == null || this.mEndDate == null) {
      this.mSnackbar.open('Please select a date range', '', {
        duration: 3000,
        panelClass: 'success'
      });
      return;
    }
    this.LoaderService.setLoading(true);
    this.loadDonationIndex();
    try {
      const res = await this.razorpay.getAllTransactionsByDateRange(new Date(this.mStartDate), new Date(this.mEndDate));
      this.dataSource = new MatTableDataSource<any>(res.items);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;

      // Custom filter: match exact status
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        return !filter || data.status?.toLowerCase() === filter;
      };

      // Re-apply any active status filter
      this.dataSource.filter = this.selectedStatus.trim().toLowerCase();

      // Populate dropdown options from actual data
      this.getUniqueStatuses();

      if (res.truncatedDays.length) {
        this.mSnackbar.open(`Some payments may be missing for ${res.truncatedDays.join(', ')} (100 or more in one day)`, 'OK', {
          panelClass: 'error'
        });
      }
    } catch (err) {
      console.error('Error fetching transactions:', err);
      this.mSnackbar.open('Failed to load data', '', {
        duration: 3000,
        panelClass: 'error'
      });
    } finally {
      this.LoaderService.setLoading(false);
    }
  }

  //* Donations store the Razorpay payment id or order id in order_id (manual entries also use payment_id)
  private async loadDonationIndex() {
    try {
      const snap = await firstValueFrom(this.mFirestore.collection(this.env.donations).get());
      const index = new Map<string, AddedDonation>();
      snap.docs.forEach(doc => {
        const data = doc.data() as any;
        const donation = {id: doc.id, receipt_id: data.receipt_id || ''};
        [data.order_id, data.payment_id].forEach(key => {
          if (key) index.set(String(key).trim(), donation);
        });
      });
      this.donationIndex = index;
    } catch (err) {
      console.error('Error fetching donations:', err);
      this.mSnackbar.open('Could not check which payments are already in donations', '', {
        duration: 3000,
        panelClass: 'error'
      });
    }
  }

  getDonation(payment: any): AddedDonation | undefined {
    return this.donationIndex.get(payment.id) || (payment.order_id ? this.donationIndex.get(payment.order_id) : undefined);
  }

  addToDonations(payment: any) {
    this.mDialog.open(AddRazorpayDonationComponent, {
      width: '800px',
      maxHeight: '95vh',
      disableClose: true,
      data: payment
    }).afterClosed().subscribe((added?: AddedDonation) => {
      if (added) this.donationIndex.set(payment.id, added);
    });
  }

  getDate(created_at: any) {
        return  this.datePipe.transform( new Date(created_at*1000),'dd-MMM-yyyy hh:mm:aa')
    }
}
